import { Message } from 'element-ui'

const SAFETY_SING = 'UniDocSafe(www.leagsoft.com)'

const VIDEO = ['mp4', 'gif']

const hexToString = (hex) => {
  let str = ''
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  }
  return str
}

/**
 * 读取文件的前28个字节
 * @param {File} file - 要读取的文件
 * @returns {Promise} - 包含十六进制和十进制字节数据的Promise
 */
function readFileBytes (file) {
  return new Promise((resolve, reject) => {
    const byteCount = 28 // 只读取文件的前28个字节
    const blob = file.slice(0, byteCount) // 从0位置开始，读取28个字节

    const reader = new FileReader()
    reader.readAsArrayBuffer(blob)

    reader.onload = (e) => {
      try {
        const arrayBuffer = e.target.result
        const uint8Array = new Uint8Array(arrayBuffer)

        // 原始十六进制表示
        // const hexBytes = []
        // 转换为十六进制表示
        const decimalBytes = []

        for (let i = 0; i < uint8Array.length; i++) {
          // 十六进制：确保两位表示，大写形式
          // hexBytes.push(uint8Array[i].toString(16).toUpperCase().padStart(2, '0'))
          decimalBytes.push(hexToString(uint8Array[i].toString(16).toUpperCase().padStart(2, '0')))
        }

        resolve({
          // hex: hexBytes.join(''),
          decimal: decimalBytes.join('')
        })
      } catch (error) {
        reject(new Error('文件读取失败: ' + error.message))
      }
    }

    reader.onerror = () => {
      reject(new Error('文件读取错误: ' + reader.error.message))
    }
  })
}

function resolveFile (file) {
  const { name } = file
  const extension = name.indexOf('.') > -1 ? `${name.split('.').pop()}` : ''
  return {
    extension: extension.toLowerCase()
  }
}


export async function isEncryptedByVideoFile (file, msg = '检测到跨声录制的加密视频，请在桌面通过右键文档解密后上传!') {
  let isEncrypted = false
  try {
    const _file = resolveFile(file)
    if (VIDEO.includes(_file.extension)) {
      const data = await readFileBytes(file)
      isEncrypted = data.decimal === SAFETY_SING
    }
  } catch (error) {
    isEncrypted = false
  }

  if (isEncrypted && msg) {
    Message.warning(msg)
  }

  return isEncrypted
}



// WEBPACK FOOTER //
// ./src/public/utils/safety.js